import { Palette } from 'core/config';
import styled from 'styled-components';

export const InfoContainer = styled.div`
    display: flex;
    width: 100%;
    margin-top: 10rem;
    justify-content: center;
`;

export const InfoCard = styled.div`
    width: 40rem;
    min-height: 40rem;
    border-radius: 3rem;
    background-color: ${Palette.TAN};
    padding: 3rem;
    box-sizing: border-box;

    @media only screen and (max-width: 600px) {
        width: 95%;
        padding: 3rem 2rem;
    }
`;

export const InfoContent = styled.div`
    padding: 1rem 2rem;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

    @media only screen and (max-width: 600px) {
        padding: 1rem 1rem;
    }
`;

export const InfoTitle = styled.h1`
    color: ${Palette.BLUE};
    font-family: SofiaPro-Bold;
    margin-bottom: 2rem;
`;

export const InfoQuestion = styled.p`
    color: ${Palette.BLUE};
    font-family: SofiaPro-Regular;
    font-size: 14px;
    margin-bottom: 2rem;
    white-space: pre-line;
`;

export const SubmitButton = styled.button`
    margin-top: auto;
    width: 100%;
    background-color: ${Palette.ORANGE};
    color: ${Palette.WHITE};
    border: none;
    padding: 1rem 2rem;
    border-radius: 1rem;
    font-family: SofiaPro-Regular;
    font-size: 16px;
    cursor: pointer;

    &:disabled {
        opacity: 0.4;
    }
`;

export const NoInfo = styled.h2`
    color: ${Palette.BLUE};
    font-family: SofiaPro-Bold;
`;

export const DocumentItem = styled.div`
    background-color: ${Palette.EGGSHELL_WHITE};
    padding: 1rem;
    margin: 1.5rem 0;
    border-radius: 11px;
`;

export const HiddenInput = styled.input`
    display: none;
`;

export const DocumentImage = styled.img<{solid?: boolean}>`
    opacity: ${({ solid }) => solid ? '1' : '0.5'};
`;

export const DocumentItemName = styled.div<{ selected?: boolean;}>`
    overflow: hidden;
    margin-left: 22px;
    font: normal normal normal 13px 'SofiaPro-Regular';
    ${({ selected }) => selected ? 'color: black;' : `color: ${Palette.DOVE_GREY};`}
`;

export const DocumentItemContent = styled.div`
    display: flex;
    align-items: center;
    width: 100%;

    svg {
        width: 22px !important;
        height: 22px !important;
    }
`;

export const DocumentPreview = styled.div<{ selectView: boolean; }>`
    width: 100%;
    border-radius: 11px;
    margin-bottom: 24px;
    position: relative;

    ${({ selectView }) => selectView && `
        &:hover {
            cursor: pointer;
        }
    `}
`;
